// Module
var code = `<table class="table">
  <thead>
  <tr>
    <th> No</th>
    <th> Client name</th>
    <th> Principal</th>
    <th> Interest</th>
    <th ng-if="\$ctrl.totalDocStamp!=0">DocStamp</th>
    <th ng-if="\$ctrl.totalNotarialFee!=0"> Notarial Fee</th>
    <th ng-if="\$ctrl.totalApplicationFee!=0"> Application Fee</th>
    <th ng-if="\$ctrl.totalCreditInvestigationFee!=0"> Credit Investigation Fee</th>
    <th ng-if="\$ctrl.totalExtraBankFee!=0"> Extra Bank Fee</th>
    <th ng-if="\$ctrl.totalServiceCharge!=0"> Service Charge</th>
    <th ng-if="\$ctrl.totalMembershipFee!=0"> Membership Fee</th>
    <th ng-if="\$ctrl.totalIdFee!=0"> Id Fee</th>
    <th ng-if="\$ctrl.totalInsuranceFee!=0"> Insurance Fee</th>
    <th ng-if="\$ctrl.totalInsuranceServiceFee!=0"> Insurance Service Fee</th>
    <th ng-if="\$ctrl.totalInsuranceProcessingFee!=0"> Insurance Processing Fee</th>
    <th>
      Release <input type="checkbox" ng-checked="\$ctrl.allSelected()" ng-click="\$ctrl.handleCheckAll(\$event)"/>
    </th>
  </tr>
  </thead>
  <tbody>
  <tr ng-repeat="item in \$ctrl.loans track by \$index">
    <td>{{\$index+1}}</td>
    <td>{{item.customer}}</td>
    <td>
      <cash ng-model="item.principalBalance" ng-disabled="true"></cash>
    </td>
    <td>
      <cash ng-model="item.interestBalance" ng-disabled="true"></cash>
    </td>

    <td ng-if="\$ctrl.totalDocStamp!=0">
      <cash ng-model="item.docStamp" ng-disabled="true"></cash>
    </td>
    <td ng-if="\$ctrl.totalNotarialFee!=0">
      <cash ng-model="item.notarialFee" ng-disabled="true"></cash>
    </td>
    <td ng-if="\$ctrl.totalApplicationFee!=0">
      <cash ng-model="item.applicationFee" ng-disabled="true"></cash>
    </td>
    <td ng-if="\$ctrl.totalCreditInvestigationFee!=0">
      <cash ng-model="item.creditInvestigationFee" ng-disabled="true"></cash>
    </td>
    <td ng-if="\$ctrl.totalExtraBankFee!=0">
      <cash ng-model="item.extraBankFee" ng-disabled="true"></cash>
    </td>
    <td ng-if="\$ctrl.totalServiceCharge!=0">
      <cash ng-model="item.serviceCharge" ng-disabled="true"></cash>
    </td>
    <td ng-if="\$ctrl.totalMembershipFee!=0">
      <cash ng-model="item.membershipFee" ng-disabled="true"></cash>
    </td>
    <td ng-if="\$ctrl.totalIdFee!=0">
      <cash ng-model="item.idFee" ng-disabled="true"></cash>
    </td>
    <td ng-if="\$ctrl.totalInsuranceFee!=0">
      <cash ng-model="item.insuranceFee" ng-disabled="true"></cash>
    </td>
    <td ng-if="\$ctrl.totalInsuranceServiceFee!=0">
      <cash ng-model="item.insuranceServiceFee" ng-disabled="true"></cash>
    </td>
    <td ng-if="\$ctrl.totalInsuranceProcessingFee!=0">
      <cash ng-model="item.insuranceProcessingFee" ng-disabled="true"></cash>
    </td>
    <td>
      <input type="checkbox" ng-model="item.forRelease"/>
    </td>
  </tr>

  <tr>
    <td>
    </td>
    <td><b>Total:</b></td>
    <td ng-if="\$ctrl.totalPrincipal!=0">
      <cash ng-model="\$ctrl.totalPrincipal" ng-disabled="true"></cash>
    </td>
    <td ng-if="\$ctrl.totalInterest!=0">
      <cash ng-model="\$ctrl.totalInterest" ng-disabled="true"></cash>
    </td>
    <td ng-if="\$ctrl.totalDocStamp!=0">
      <cash ng-model="\$ctrl.totalDocStamp" ng-disabled="true"></cash>
    </td>
    <td ng-if="\$ctrl.totalNotarialFee!=0">
      <cash ng-model="\$ctrl.totalNotarialFee" ng-disabled="true"></cash>
    </td>
    <td ng-if="\$ctrl.totalApplicationFee!=0">
      <cash ng-model="\$ctrl.totalApplicationFee" ng-disabled="true"></cash>
    </td>
    <td ng-if="\$ctrl.totalCreditInvestigationFee!=0">
      <cash ng-model="\$ctrl.totalCreditInvestigationFee" ng-disabled="true"></cash>
    </td>
    <td ng-if="\$ctrl.totalExtraBankFee!=0">
      <cash ng-model="\$ctrl.totalExtraBankFee" ng-disabled="true"></cash>
    </td>
    <td ng-if="\$ctrl.totalServiceCharge!=0">
      <cash ng-model="\$ctrl.totalServiceCharge" ng-disabled="true"></cash>
    </td>
    <td ng-if="\$ctrl.totalMembershipFee!=0">
      <cash ng-model="\$ctrl.totalMembershipFee" ng-disabled="true"></cash>
    </td>
    <td ng-if="\$ctrl.totalIdFee!=0">
      <cash ng-model="\$ctrl.totalIdFee" ng-disabled="true"></cash>
    </td>
    <td ng-if="\$ctrl.totalInsuranceFee!=0">
      <cash ng-model="\$ctrl.totalInsuranceFee" ng-disabled="true"></cash>
    </td>
    <td ng-if="\$ctrl.totalInsuranceServiceFee!=0">
      <cash ng-model="\$ctrl.totalInsuranceServiceFee" ng-disabled="true"></cash>
    </td>
    <td ng-if="\$ctrl.totalInsuranceProcessingFee!=0">
      <cash ng-model="\$ctrl.totalInsuranceProcessingFee" ng-disabled="true"></cash>
    </td>
  </tr>
  </tbody>

</table>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/check-release/group-loan-information.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;